import React, { Component } from "react";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import GoToTop from "@components/GoToTop";

// Pages
import AgendaList from "@pages/agenda/list";
import AnuladosList from "@pages/anulados/list";
import CalendarList from "@pages/calendar/list";
import Categories from "@pages/categories/list";
import CC from "@pages/cc/list";
import ClientesList from "@pages/clientes/list";
import CustomersList from "@pages/customers/list";
import EmployeesList from "@pages/employees/list";
import EstimatesList from "@pages/estimates/list";
import GuiasList from "@pages/guias/list";
import KanbanList from "@pages/kanban/list";
import OrdersList from "@pages/orders/list";
import PartnersList from "@pages/partners/list";
import PaymentsList from "@pages/payments/list";
import PricetagsList from "@pages/pricetags/list";
import ProductsList from "@pages/products/list";
import ProvidersList from "@pages/providers/list";
import NozzlesList from "@pages/nozzles/list";
import PsaList from "@pages/psa/list";
import SalesList from "@pages/sales/list";
import SegmentacaoList from "@pages/segmentacao/list";
import SequencesList from "@pages/sequences/list";
import StocksList from "@pages/stocks/list";
import TaxesList from "@pages/taxes/list";
import TicketsList from "@pages/tickets/list";
import TourniquetList from "@pages/tourniquet/list";
import MenuPermissionsList from "@pages/menu-permissions/list";

import ClientesForm from "@pages/clientes/form";
import CustomersForm from "@pages/customers/form";
import EmployeesForm from "@pages/employees/form";
import EstimatesForm from "@pages/estimates/form";
import HouseholdForm from "@pages/customers/household/form";
import OrdersForm from "@pages/orders/form";
import PartnersForm from "@pages/partners/form";
import PhotosForm from "@pages/customers/services/photos";
import PricetagsForm from "@pages/pricetags/edit";
import ProductsForm from "@pages/products/form";
import ProvidersForm from "@pages/providers/form";
import PsaForm from "@pages/psa/form";
import QuotasForm from "@pages/customers/quotas/form";
import SalesForm from "@pages/sales/form";
import ServicesForm from "@pages/customers/services/form";
import PaymentsForm from "@pages/payments/form";
import ProvidersPaymentForm from "@pages/payments/providers-form";

import SalesType from "@pages/sales/type";
import OrdersType from "@pages/orders/type";
import PaymentsType from "@pages/payments/type";

import ZonesMap from "@pages/zones";

import SequencesBulk from "@pages/sequences/bulk";

import PricesCombustiveis from "@pages/prices/combustivel";

import ConsumptionVehicles from "@pages/consumption/vehicles";

import ProductsSync from "@pages/products/sync";
import ProductsPricetags from "@pages/products/pricetags";
import ProductsPricetagsProducts from "@pages/products/pricetagsproducts";

import GuiasView from "@pages/guias/view";
import OrdersView from "@pages/orders/view";
import PaymentsView from "@pages/payments/view";
import PsaView from "@pages/psa/view";
import SalesView from "@pages/sales/view";
import RecibosView from "@pages/sales/recibos/view";
import VeederRootView from "@pages/veeder-root/view";

import PsaLogs from "@pages/psa/logs";

import CustomersListPOS from "@pages/pos/customers/list";
import CustomersPOS from "@pages/pos/customers";
import HomePOS from "@pages/pos";
import InventoryNewPOS from "@pages/pos/inventory/new";
import InventoryPOS from "@pages/pos/inventory";
import TicketsNewPOS from "@pages/pos/tickets/new";
import TicketsPOS from "@pages/pos/tickets";
import TicketsReadPOS from "@pages/pos/tickets/read";

import InoutPublic from "@pages/public/inout";

import UserContext from "@components/context/userContext";
import ProtectedRoute from "@components/ProtectedRoute";
import RouteGuard from "@components/RouteGuard";

const changeFavicon = (url) => {
  let link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "shortcut icon";
  link.href = url;
  document.getElementsByTagName("head")[0].appendChild(link);
};

class Page extends Component {
  static contextType = UserContext;

  render() {
    const profile = this.context;
    const hydratedProps = (props) => ({ ...props, profile });

    return (
      <div>
        <Router>
          <RouteGuard>
            <Switch>
            <Route
              path="/categories"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:categories"
                  render={() => {
                    document.title = "ePOS - Categorias";
                    return <Categories {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/cc"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:cc"
                  render={() => {
                    document.title = "ePOS - Documentos Pendentes";
                    return <CC {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - Clientes";
                    return <CustomersList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - Clientes";
                    return <CustomersForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/services/new"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:services"
                  render={() => {
                    document.title = "ePOS - Serviços";
                    return <ServicesForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/services/:idservice/photos"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:services"
                  render={() => {
                    document.title = "ePOS - Serviços";
                    return <PhotosForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/services/:idservice"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:services"
                  render={() => {
                    document.title = "ePOS - Serviços";
                    return <ServicesForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/household/new"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - agregado";
                    return <HouseholdForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/household/:idhousehold"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - Agregado";
                    return <HouseholdForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/quotas/new"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - Quotas";
                    return <QuotasForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer/quotas/:idquota"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - Quotas";
                    return <QuotasForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/customers/:idcustomer"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:customers"
                  render={() => {
                    document.title = "ePOS - Clientes";
                    return <CustomersForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/estimates"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="accounting:estimates"
                  render={() => {
                    document.title = "ePOS - Sondagens";
                    return <EstimatesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/estimates/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="accounting:estimates"
                  render={() => {
                    document.title = "ePOS - Sondagens";
                    return <EstimatesForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/estimates/:idproduct"
              render={(props) => (
                <ProtectedRoute
                  permission="accounting:estimates"
                  render={() => {
                    document.title = "ePOS - Sondagens";
                    return <EstimatesForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/partners"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:partners"
                  render={() => {
                    document.title = "ePOS - Parceiros";
                    return <PartnersList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/partners/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:partners"
                  render={() => {
                    document.title = "ePOS - Parceiros";
                    return <PartnersForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/partners/:idpartner"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:partners"
                  render={() => {
                    document.title = "ePOS - Parceiros";
                    return <PartnersForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/providers"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:providers"
                  render={() => {
                    document.title = "ePOS - Fornecedores";
                    return <ProvidersList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/providers/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:providers"
                  render={() => {
                    document.title = "ePOS - Fornecedores";
                    return <ProvidersForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/providers/:idprovider"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:providers"
                  render={() => {
                    document.title = "ePOS - Fornecedores";
                    return <ProvidersForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Produtos";
                    return <ProductsList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Produtos";
                    return <ProductsForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/sync"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Produtos";
                    return <ProductsSync {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/pricetags/:warehouse/:pricetag"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Etiquetas";
                    return <ProductsPricetagsProducts {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/pricetags"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Etiquetas";
                    return <ProductsPricetags {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/:idproduct/:tabIndex/:redirect"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Produtos";
                    return <ProductsForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/:idproduct/:tabIndex"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Produtos";
                    return <ProductsForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/products/:idproduct"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:products"
                  render={() => {
                    document.title = "ePOS - Produtos";
                    return <ProductsForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/orders"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/orders/new/:doctype"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/orders/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersType {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/orders/edit/:doctype/:idorder"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/invoices/:talao/warehouses/:posto/series/:serie/tpvs/:tpv/products/:idproduct"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/orders/:idorder/products/:idproduct"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/orders/:idorder"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:orders"
                  render={() => {
                    document.title = "ePOS - Compras";
                    return <OrdersView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/sales"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:sales"
                  render={() => {
                    document.title = "ePOS - Faturação";
                    return <SalesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/sales/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:sales"
                  render={() => {
                    document.title = "ePOS - Faturação";
                    return <SalesType {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/sales/new/:doctype"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:sales"
                  render={() => {
                    document.title = "ePOS - Faturação";
                    return <SalesForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            {/* <Route
              path="/sales/:idsale/products/:idproduct"
              render={(props) => {
                document.title = 'ePOS - Faturação';
                return (
                  <SalesView {...hydratedProps(props)} />
                );
              }}
            /> */}
            <Route
              path="/sales/:doctype/:posto/:tpv/:serie/:doc"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:sales"
                  render={() => {
                    document.title = "ePOS - Faturação";
                    return <SalesView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/sales/:doctype/:datetime/:serie/:doc"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:sales"
                  render={() => {
                    document.title = "ePOS - Faturação";
                    return <RecibosView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/sales/:doctype/:serie/:doc"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:sales"
                  render={() => {
                    document.title = "ePOS - Faturação";
                    return <SalesView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/payments"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:payments"
                  render={() => {
                    document.title = "ePOS - Pagamentos";
                    return <PaymentsList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/payments/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:payments"
                  render={() => {
                    document.title = "ePOS - Pagamentos";
                    return <PaymentsType {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/payments/new/:type"
              exact
              render={(props) => {
                const type = props.match?.params?.type;
                return (
                  <ProtectedRoute
                    permission="documents:payments"
                    render={() => {
                      document.title = "ePOS - Pagamentos";
                      if (type === "providers") {
                        return <ProvidersPaymentForm {...hydratedProps(props)} type="new" />;
                      }
                      return <PaymentsForm {...hydratedProps(props)} type="new" />;
                    }}
                    {...props}
                  />
                );
              }}
            />
            <Route
              path="/payments/view/:numero"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:payments"
                  render={() => {
                    document.title = "ePOS - Detalhe do Recibo";
                    return <PaymentsView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/pricetags"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:pricetags"
                  render={() => {
                    document.title = "ePOS - Etiquetas";
                    return <PricetagsList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pricetags/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:pricetags"
                  render={() => {
                    document.title = "ePOS - Etiquetas";
                    return <PricetagsForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pricetags/:idpricetag"
              render={(props) => (
                <ProtectedRoute
                  permission="config:pricetags"
                  render={() => {
                    document.title = "ePOS - Etiquetas";
                    return <PricetagsForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/nozzles"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:nozzles"
                  render={() => {
                    document.title = "ePOS - Associações Mangueiras-Produtos";
                    return <NozzlesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/psa"
              exact
              render={(props) => {
                document.title = "ePOS - PumpServerApollo";
                return <PsaList {...hydratedProps(props)} />;
              }}
            />
            <Route
              path="/psa/:idpsa/config"
              render={(props) => {
                document.title = "ePOS - PumpServerApollo";
                return <PsaForm {...hydratedProps(props)} />;
              }}
            />
            <Route
              path="/psa/:idpsa/logs"
              render={(props) => {
                document.title = "ePOS - PumpServerApollo";
                return <PsaLogs {...hydratedProps(props)} />;
              }}
            />
            <Route
              path="/psa/:idpsa"
              render={(props) => {
                document.title = "ePOS - PumpServerApollo";
                return <PsaView {...hydratedProps(props)} />;
              }}
            />
            <Route
              path="/veeder-root"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:veeder_root"
                  render={() => {
                    document.title = "ePOS - VeederRoot";
                    return <VeederRootView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/employees"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:employees"
                  render={() => {
                    document.title = "ePOS - Colaboradores";
                    return <EmployeesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/employees/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:employees"
                  render={() => {
                    document.title = "ePOS - Colaboradores";
                    return <EmployeesForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/prices/combustivel"
              render={(props) => (
                <ProtectedRoute
                  permission="config:prices_combustivel"
                  render={() => {
                    document.title = "ePOS - Preços";
                    return <PricesCombustiveis {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/employees/:idemployee"
              render={(props) => (
                <ProtectedRoute
                  permission="config:employees"
                  render={() => {
                    document.title = "ePOS - Colaboradores";
                    return <EmployeesForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/tickets"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:tickets"
                  render={() => {
                    document.title = "ePOS - Senhas";
                    return <TicketsList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/stocks"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="accounting:stocks"
                  render={() => {
                    document.title = "ePOS - Stocks";
                    return <StocksList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/agenda"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:agenda"
                  render={() => {
                    document.title = "ePOS - Agenda";
                    return <AgendaList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/calendar"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:calendar"
                  render={() => {
                    document.title = "ePOS - Calendário";
                    return <CalendarList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/series"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:series"
                  render={() => {
                    document.title = "ePOS - Séries";
                    return <SequencesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/series/bulk"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:series"
                  render={() => {
                    document.title = "ePOS - Séries";
                    return <SequencesBulk {...hydratedProps(props)} type="bulk" />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/taxes"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:taxes"
                  render={() => {
                    document.title = "ePOS - Impostos";
                    return <TaxesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/guias"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="documents:guias"
                  render={() => {
                    document.title = "ePOS - Guias";
                    return <GuiasList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/guias/:doc"
              render={(props) => (
                <ProtectedRoute
                  permission="documents:guias"
                  render={() => {
                    document.title = "ePOS - Guias";
                    return <GuiasView {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/clientes"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:clients"
                  render={() => {
                    document.title = "ePOS - Clientes";
                    return <ClientesList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/clientes/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:clients"
                  render={() => {
                    document.title = "ePOS - Clientes";
                    return <ClientesForm {...hydratedProps(props)} type="new" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/clientes/:codigo"
              render={(props) => (
                <ProtectedRoute
                  permission="tools:clients"
                  render={() => {
                    document.title = "ePOS - Clientes";
                    return <ClientesForm {...hydratedProps(props)} type="edit" />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/tourniquet"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="tools:tourniquet"
                  render={() => {
                    document.title = "ePOS - Torniquete";
                    return <TourniquetList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/consumption/vehicles"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="accounting:consumption/vehicles"
                  render={() => {
                    document.title = "ePOS - Consumos por matricula";
                    return <ConsumptionVehicles {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/kanban"
              exact
              render={(props) => {
                document.title = "ePOS - Tarefas";
                return <KanbanList {...hydratedProps(props)} />;
              }}
            />

            <Route
              path="/anulados"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="admin:anulados"
                  render={() => {
                    document.title = "ePOS - Anulados";
                    return <AnuladosList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/menu-permissions"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="admin:menu_permissions"
                  render={() => {
                    document.title = "ePOS - Gestão de Permissões";
                    return <MenuPermissionsList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/segmentacao"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:segmentacao"
                  render={() => {
                    document.title = "ePOS - Segmentações";
                    return <SegmentacaoList {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/zones"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="config:zones"
                  render={() => {
                    document.title = "ePOS - Zonas";
                    return <ZonesMap {...hydratedProps(props)} />;
                  }}
                  {...props}
                />
              )}
            />

            <Route
              path="/pos"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission={null}
                  render={() => {
                    document.title = "ePOS - POS";
                    return <HomePOS {...hydratedProps(props)} POSMenu="home" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/home"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission={null}
                  render={() => {
                    document.title = "ePOS - POS";
                    return <HomePOS {...hydratedProps(props)} POSMenu="home" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/customers"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:customers"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <CustomersPOS {...hydratedProps(props)} POSMenu="customers" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/customers/list"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:customers"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <CustomersListPOS {...hydratedProps(props)} POSMenu="customers" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/tickets"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:tickets"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <TicketsPOS {...hydratedProps(props)} POSMenu="tickets" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/tickets/read"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:tickets"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <TicketsReadPOS {...hydratedProps(props)} POSMenu="tickets" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/tickets/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:tickets"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <TicketsNewPOS {...hydratedProps(props)} POSMenu="tickets" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/inventory"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:inventory"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <InventoryPOS {...hydratedProps(props)} POSMenu="inventory" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/pos/inventory/new"
              exact
              render={(props) => (
                <ProtectedRoute
                  permission="pos:inventory"
                  render={() => {
                    document.title = "ePOS - POS";
                    return <InventoryNewPOS {...hydratedProps(props)} POSMenu="inventory" />;
                  }}
                  {...props}
                />
              )}
            />
            <Route
              path="/public/inout"
              exact
              render={(props) => {
                document.title = "Registo de Entradas";
                changeFavicon(
                  "https://eposgestofinal.com/site/images/clock.ico"
                );
                return (
                  <InoutPublic
                    {...hydratedProps(props)}
                    ePOSOptions={{
                      menu: false,
                      breadCrumbs: false,
                      public: true,
                    }}
                  />
                );
              }}
            />
            <Route
              path="/"
              exact
              component={() => {
                window.location.href = "https://eposgestofinal.com/";
                return null;
              }}
            />
            <Route
              path="*"
              component={({ location: { pathname } }) => {
                window.location.href = `https://eposgestofinal.com${pathname}`;
                return null;
              }}
            />
            </Switch>
          </RouteGuard>
        </Router>
        <GoToTop />
      </div>
    );
  }
}

export default Page;
